import { createStore } from "easy-peasy";
import applicationModel, { ApplicationModel } from "models/applications";
import bankStatementsModel, { BankStatementsModel } from "models/applications/BankStatementsModel";
import fileUploadModel, {
  FileUploadModel,
} from "./models/applications/DealApplicationFileUploadModel";
import docGenerationModel, {
  DocumentTemplateModel,
} from "./models/documentGeneration/DocumentGenerationStore";
import dealApplicationModel, {
  DealApplicationStoreModel,
} from "models/applications/dealApplicationStore";
import offerStore, { OfferStoreModel } from "models/applications/OfferStore";
import heldBackComissionStore, {
  HeldBackComissionModel,
} from "models/applications/heldbackComissionStore";
import syndicationStore, { SyndicationStoreModel } from "models/applications/syndicationStore";
import bankSummaryStore, { BankSummaryStoreModel } from "models/applications/bankSummaryStoreModel";

export interface StoreModel {
  applications: ApplicationModel;
  bankStatements: BankStatementsModel;
  fileUploads: FileUploadModel;
  docGen: DocumentTemplateModel;
  dealApplication: DealApplicationStoreModel;
  offerStore: OfferStoreModel;
  heldBackCommissionStore: HeldBackComissionModel;
  syndicationStore: SyndicationStoreModel;
  bankSummaryStore: BankSummaryStoreModel;
}

const storeModel: StoreModel = {
  applications: applicationModel,
  bankStatements: bankStatementsModel,
  fileUploads: fileUploadModel,
  docGen: docGenerationModel,
  dealApplication: dealApplicationModel,
  offerStore: offerStore,
  heldBackCommissionStore: heldBackComissionStore,
  syndicationStore: syndicationStore,
  bankSummaryStore: bankSummaryStore,
};

const store = createStore(storeModel);

export default store;
